import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteService {

  constructor(private router: Router) {

  }
  userDetail(userId: number) {
    this.router.navigate([`/app/general-settings/users/${userId}`]);
  }
  userCreate() {
    this.router.navigate([`/app/general-settings/users/create`]);
  }
  userUpdate(userId: number) {
    this.router.navigate([`/app/general-settings/users/update/${userId}`]);
  }
  customerDetail(clientId: number) {
    this.router.navigate([`/app/clients/${clientId}`]);
  }
  customerCreate() {
    this.router.navigate([`/app/clients/create`]);
  }
  customerUpdate(clientId: number) {
    this.router.navigate([`/app/clients/update/${clientId}`]);
  }

  customerSettingsClientTypesDetail(clientId: number) {
    this.router.navigate([`/app/clients/settings/client-types/${clientId}`]);
  }
  customerSettingsClientTypesCreate() {
    this.router.navigate([`/app/clients/settings/client-types/create`]);
  }
  customerSettingsClientTypesUpdate(clientId: number) {
    this.router.navigate([`/app/clients/settings/client-types/update/${clientId}`]);
  }


  /*************************
    START   GENERAL SETTINGS
   *************************/
  categoryCreate() {
    this.router.navigate([`/app/general-settings/categories/create`]);
  }
  categoryDetail(categoryId: number) {
    this.router.navigate([`/app/general-settings/categories/${categoryId}`]);
  }
  categoryUpdate(categoryId: number) {
    this.router.navigate([`/app/general-settings/categories/update/${categoryId}`]);
  }
  companyCreate() {
    this.router.navigate([`/app/general-settings/companies/create`]);
  }
  companyDetail(companyId: number) {
    this.router.navigate([`/app/general-settings/companies/${companyId}`]);
  }
  companyUpdate(companyId: number) {
    this.router.navigate([`/app/general-settings/companies/update/${companyId}`]);
  }

  jurisdictionCreate() {
    this.router.navigate([`/app/general-settings/jurisdictions/create`]);
  }
  jurisdictionDetail(jurisdictionId: number) {
    this.router.navigate([`/app/general-settings/jurisdictions/${jurisdictionId}`]);
  }
  jurisdictionUpdate(jurisdictionId: number) {
    this.router.navigate([`/app/general-settings/jurisdictions/update/${jurisdictionId}`]);
  }
  itemTypesCreate() {
    this.router.navigate([`/app/general-settings/item-types/create`]);
  }
  itemTypesDetail(itemTypesId: number) {
    this.router.navigate([`/app/general-settings/item-types/${itemTypesId}`]);
  }
  itemTypesUpdate(itemTypesId: number) {
    this.router.navigate([`/app/general-settings/item-types/update/${itemTypesId}`]);
  }
  itemProductsCreate() {
    this.router.navigate([`/app/general-settings/item-products/create`]);
  }
  itemProductsDetail(itemProductsId: number) {
    this.router.navigate([`/app/general-settings/item-products/${itemProductsId}`]);
  }
  itemProductsUpdate(itemProductsId: number) {
    this.router.navigate([`/app/general-settings/item-products/update/${itemProductsId}`]);
  }
  companyLocationsCreate() {
    this.router.navigate([`/app/general-settings/company-locations/create`]);
  }
  companyLocationsDetail(companyLocationsId: number) {
    this.router.navigate([`/app/general-settings/company-locations/${companyLocationsId}`]);
  }
  companyLocationsUpdate(companyLocationsId: number) {
    this.router.navigate([`/app/general-settings/company-locations/update/${companyLocationsId}`]);
  }
  specialisationCreate() {
    this.router.navigate([`/app/hr/specialisations/create`]);
  }
  specialisationDetail(specialisationId: number) {
    this.router.navigate([`/app/hr/specialisations/${specialisationId}`]);
  }
  specialisationUpdate(specialisationId: number) {
    this.router.navigate([`/app/hr/specialisations/update/${specialisationId}`]);
  }

  lawsCreate() {
    this.router.navigate([`/app/general-settings/laws/create`]);
  }
  lawsDetail(lawsId: number) {
    this.router.navigate([`/app/general-settings/laws/${lawsId}`]);
  }
  lawsUpdate(lawsId: number) {
    this.router.navigate([`/app/general-settings/laws/update/${lawsId}`]);
  }
  regulationsCreate() {
    this.router.navigate([`/app/general-settings/regulations/create`]);
  }
  regulationsDetail(regulationsId: number) {
    this.router.navigate([`/app/general-settings/regulations/${regulationsId}`]);
  }
  regulationsUpdate(regulationsId: number) {
    this.router.navigate([`/app/general-settings/regulations/update/${regulationsId}`]);
  }
  itemsCreate() {
    this.router.navigate([`/app/general-settings/items/create`]);
  }
  itemsDetail(itemsId: number) {
    this.router.navigate([`/app/general-settings/items/${itemsId}`]);
  }
  itemsUpdate(itemsId: number) {
    this.router.navigate([`/app/general-settings/items/update/${itemsId}`]);
  }

  /*************************
    END   GENERAL SETTINGS 
   *************************/

  requestsCreate() {
    this.router.navigate([`/app/requests/create`]);
  }
  requestsDetail(requestId: number) {
    this.router.navigate([`/app/requests/${requestId}`]);
  }
  requestsUpdate(requestId: number) {
    this.router.navigate([`/app/requests/update/${requestId}`]);
  }

  requestsSettingsRequestCategoriesCreate() {
    this.router.navigate([`/app/requests/settings/request-categories/create`]);
  }
  requestsSettingsRequestCategoriesDetail(requestCategoryId: number) {
    this.router.navigate([`/app/requests/settings/request-categories/${requestCategoryId}`]);
  }
  requestsSettingsRequestCategoriesUpdate(requestCategoryId: number) {
    this.router.navigate([`/app/requests/settings/request-categories/update/${requestCategoryId}`]);
  }

  activitiesPlanningIndex() {
    this.router.navigate([`/app/quality-management/activities-planning`]);
  }
  activitiesPlanningCreate() {
    this.router.navigate([`/app/quality-management/activities-planning/create`]);
  }
  activitiesPlanningDetail(planningId: number) {
    this.router.navigate([`/app/quality-management/activities-planning/${planningId}`]);
  }
  activitiesPlanningUpdate(planningId: number) {
    this.router.navigate([`/app/quality-management/activities-planning/update/${planningId}`]);
  }

  qualityDocumentGroupIndex() {
    this.router.navigate([`/app/quality-management/settings/quality-document-group`]);
  }
  qualityDocumentGroupCreate() {
    this.router.navigate([`/app/quality-management/settings/quality-document-group/create`]);
  }
  qualityDocumentGroupDetail(companyDocumentGroupId: number) {
    this.router.navigate([`/app/quality-management/settings/quality-document-group/${companyDocumentGroupId}`]);
  }
  qualityDocumentGroupUpdate(companyDocumentGroupId: number) {
    this.router.navigate([`/app/quality-management/settings/quality-document-group/update/${companyDocumentGroupId}`]);
  }

  companyDocumentsIndex() {
    this.router.navigate([`/app/quality-management/company-documents`]);
  }
  companyDocumentsCreate() {
    this.router.navigate([`/app/quality-management/company-documents/create`]);
  }
  companyDocumentsDetail(companyDocumentId: number) {
    this.router.navigate([`/app/quality-management/company-documents/${companyDocumentId}`]);
  }
  companyDocumentsUpdate(companyDocumentId: number) {
    this.router.navigate([`/app/quality-management/company-documents/update/${companyDocumentId}`]);
  }
  companyDocumentsRevisionCreate(companyDocumentId: number) {
    this.router.navigate([`/app/quality-management/company-documents/revision/create/${companyDocumentId}`]);
  }
  companyDocumentsRevisionDetail(companyDocumentRevisionId: number) {
    this.router.navigate([`/app/quality-management/company-documents/revision/${companyDocumentRevisionId}`]);
  }

  riskManagementIndex() {
    this.router.navigate([`/app/quality-management/risk-management`]);
  }
  riskManagementCreate() {
    this.router.navigate([`/app/quality-management/risk-management/create`]);
  }
  riskManagementDetail(riskId: number) {
    this.router.navigate([`/app/quality-management/risk-management/${riskId}`]);
  }
  riskManagementUpdate(riskId: number) {
    this.router.navigate([`/app/quality-management/risk-management/update/${riskId}`]);
  }

  meetingMinutesIndex() {
    this.router.navigate([`/app/quality-management/risk-management/meeting-minutes`]);
  }
  meetingMinutesCreate() {
    this.router.navigate([`/app/quality-management/risk-management/meeting-minutes/create`]);
  }
  meetingMinutesDetail(meetingMinuteId: number) {
    this.router.navigate([`/app/quality-management/risk-management/meeting-minutes/${meetingMinuteId}`]);
  }
  meetingMinutesUpdate(meetingMinuteId: number) {
    this.router.navigate([`/app/quality-management/risk-management/meeting-minutes/update/${meetingMinuteId}`]);
  }

  riskTimeFrameIndex() {
    this.router.navigate([`/app/quality-management/settings/risk-time-frame`]);
  }
  riskTimeFrameCreate() {
    this.router.navigate([`/app/quality-management/settings/risk-time-frame/create`]);
  }
  riskTimeFrameDetail(riskTimeFrameId: number) {
    this.router.navigate([`/app/quality-management/settings/risk-time-frame/${riskTimeFrameId}`]);
  }
  riskTimeFrameUpdate(riskTimeFrameId: number) {
    this.router.navigate([`/app/quality-management/settings/risk-time-frame/update/${riskTimeFrameId}`]);
  }

  complaintsCreate() {
    this.router.navigate([`/app/complaints/create`]);
  }
  complaintsUpdate(complaintId: number) {
    this.router.navigate([`/app/complaints/update/${complaintId}`]);
  }

  proposalsCreate() {
    this.router.navigate([`/app/proposals/create`]);
  }
  proposalsDetail(proposalId: number) {
    this.router.navigate([`/app/proposals/${proposalId}`]);
  }
  proposalsUpdate(proposalId: number) {
    this.router.navigate([`/app/proposals/update/${proposalId}`]);
  }
  proposalsCreateInitFromRequest(requestId?: number) {
    this.router.navigate([`/app/proposals/create`], {
      queryParams: { requestId: requestId }
    });
  }
  proposalsCreateInitFromProposal(proposalId?: number) {
    this.router.navigate([`/app/proposals/change-of-scope`], {
      queryParams: { proposalId: proposalId }
    });
  }

  proposalStepsCreate() {
    this.router.navigate([`/app/proposals/settings/proposal-steps/create`]);
  }
  proposalStepsDetail(proposalStepId: number) {
    this.router.navigate([`/app/proposals/settings/proposal-steps/${proposalStepId}`]);
  }
  proposalStepsUpdate(proposalStepId: number) {
    this.router.navigate([`/app/proposals/settings/proposal-steps/update/${proposalStepId}`]);
  }

  proposalPaymentTermsCreate() {
    this.router.navigate([`/app/proposals/settings/payment-terms/create`]);
  }
  proposalPaymentTermsDetail(proposalPaymentTermId: number) {
    this.router.navigate([`/app/proposals/settings/payment-terms/${proposalPaymentTermId}`]);
  }
  proposalPaymentTermsUpdate(proposalPaymentTermId: number) {
    this.router.navigate([`/app/proposals/settings/payment-terms/update/${proposalPaymentTermId}`]);
  }

  projectsCreate() {
    this.router.navigate([`/app/projects/create`]);
  }
  projectsDetail(proposalId: number) {
    this.router.navigate([`/app/projects/${proposalId}`]);
  }
  projectsUpdate(proposalId: number) {
    this.router.navigate([`/app/projects/update/${proposalId}`]);
  }
  projectsFinanceIncomeUrl(projectId: number): string {
    return `/projects/${projectId}/finance/income`;
  }
  projectsFinanceAnalysisUrl(projectId: number): string {
    return `/projects/${projectId}/finance/analysis`;
  }
  projectsFinanceIncome(projectId: number) {
    this.router.navigate([this.projectsFinanceIncomeUrl(projectId)]);
  }
  projectsFinanceAnalysis(projectId: number) {
    this.router.navigate([this.projectsFinanceAnalysisUrl(projectId)]);
  }
  projectsFinanceInstalmentUpdate(projectId: number, projectInvoiceId: number) {
    this.router.navigate([`/app/projects/${projectId}/finance/income/update/${projectInvoiceId}`]);
  }
  projectsFinanceTestingCostCreate(projectId: number) {
    this.router.navigate([`/app/projects/${projectId}/finance/analysis/testing-costs/create`]);
  }
  projectsFinanceOtherCostCreate(projectId: number) {
    this.router.navigate([`/app/projects/${projectId}/finance/analysis/other-costs/create`]);
  }
  projectsFinanceTestingCostUpdate(projectId: number, projectFinanceCostId: number) {
    this.router.navigate([`/app/projects/${projectId}/finance/analysis/testing-costs/update/${projectFinanceCostId}`]);
  }
  projectsFinanceOtherCostUpdate(projectId: number, projectFinanceOtherCostId: number) {
    this.router.navigate([`/app/projects/${projectId}/finance/analysis/other-costs/update/${projectFinanceOtherCostId}`]);
  }

  projectsSettingsChecklistGroupCreate() {
    this.router.navigate([`/app/projects/settings/checklist-group/create`]);
  }
  projectsSettingsChecklistGroupDetail(checklistGroupId: number) {
    this.router.navigate([`/app/projects/settings/checklist-group/${checklistGroupId}`]);
  }
  projectsSettingsChecklistGroupUpdate(checklistGroupId: number) {
    this.router.navigate([`/app/projects/settings/checklist-group/update/${checklistGroupId}`]);
  }

  projectsSettingsChecklistCreate() {
    this.router.navigate([`/app/projects/settings/checklist/create`]);
  }
  projectsSettingsChecklistDetail(proposalId: number) {
    this.router.navigate([`/app/projects/settings/checklist/${proposalId}`]);
  }
  projectsSettingsChecklistUpdate(proposalId: number) {
    this.router.navigate([`/app/projects/settings/checklist/update/${proposalId}`]);
  }

  projectsSettingsTestlistCreate() {
    this.router.navigate([`/app/projects/settings/testlist/create`]);
  }
  projectsSettingsTestlistDetail(proposalId: number) {
    this.router.navigate([`/app/projects/settings/testlist/${proposalId}`]);
  }
  projectsSettingsTestlistUpdate(proposalId: number) {
    this.router.navigate([`/app/projects/settings/testlist/update/${proposalId}`]);
  }

  campaignCreate() {
    this.router.navigate([`/app/marketing/campaigns/create`]);
  }
  campaignDetail(campaignId: number) {
    this.router.navigate([`/app/marketing/campaigns/${campaignId}`]);
  }
  campaignUpdate(campaignId: number) {
    this.router.navigate([`/app/marketing/campaigns/update/${campaignId}`]);
  }


  employeeCreate() {
    this.router.navigate([`/app/hr/employees/create`]);
  }
  employeeDetail(employeeId: number) {
    this.router.navigate([`/app/hr/employees/${employeeId}`]);
  }
  employeeUpdate(employeeId: number) {
    this.router.navigate([`/app/hr/employees/update/${employeeId}`]);
  }

  antivirusLogDetail(fileUploadLogId: number) {
    this.router.navigate([`/app/it/antivirus-fileupload-log/${fileUploadLogId}`]);
  }

  introducerCreate() {
    this.router.navigate([`/app/introducers/create`]);
  }
  introducerDetail(introducerId: number) {
    this.router.navigate([`/app/introducers/${introducerId}`]);
  }
  introducerUpdate(introducerId: number) {
    this.router.navigate([`/app/introducers/update/${introducerId}`]);
  }
  introducerRevenueList() {
    this.router.navigate([`/app/introducers/revenue-list`]);
  }
  introducerClients() {
    this.router.navigate([`/app/introducers/clients`]);
  }

  regulatorsIndex() {
    this.router.navigate([`/app/regulators`]);
  }
  regulatorClientWebsites(regulatorId: number, clientId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/clients/${clientId}`]);
  }
  regulatorVlts(regulatorId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/vlt`]);
  }
  regulatorVltDashboard(regulatorId: number, vltId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/vlt/${vltId}`]);
  }
  regulatorCreate() {
    this.router.navigate([`/app/regulators/create`]);
  }
  regulatorUpdate(regulatorId: number) {
    this.router.navigate([`/app/regulators/update/${regulatorId}`]);
  }
  regulatorClients(regulatorId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/clients`]);
  }
  regulatorWebsiteScans(regulatorId: number, clientId: number, websiteId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/clients/${clientId}/websites/${websiteId}/scans`]);
  }
  regulatorWebsiteScanDetail(regulatorId: number, clientId: number, websiteId: number, scanId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/clients/${clientId}/websites/${websiteId}/scans/${scanId}`]);
  }
  regulatorVltCreate(regulatorId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/vlt/create`]);
  }
  regulatorVltUpdate(regulatorId: number, vltId: number) {
    this.router.navigate([`/app/regulators/${regulatorId}/vlt/update/${vltId}`]);
  }

}
